import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector)
    .use(initReactI18next).init({
    debug: true,
    resources: {
        en: {
            translation: {
                "Connecting to chat, please wait...": "Connecting to chat, please wait...",
                "Welcome": "Welcome",
                "Login": "Login",
                "Username": "Username",
                "Password": "Password",
                "Field is required": "Field is required",
                "Profile": "Profile",
                "Logout": "Logout",
                "Filters": "Filters",
                "Month": "Month",
                "Not available": "Not available",
                "Real expenses list": "Expenses list",
                "Show list": "Show list",
                "Search": "Search",
                "Clear search value": "Clear search value",
                "Description": "Description",
                "Amount": "Amount",
                "Total amount": "Total amount",
                "Balance": "Balance",
                "Category": "Category",
                "Actions": "Actions",
                "No data": "No data",
                "rows per page": "rows per page",
                "Description is required": "Description is required",
                "Amount is required": "Amount is required",
                "Cancel": "Cancel",
                "Save": "Save",
                "Submit": "Submit",
                "Are you sure delete real expense": "Are you sure delete real expense",
                "Create new": "Create new",
                "List": "List",
                "Create new budget": "Create new budget",
                "Budget list": "Budget list",
                "Name": "Name",
                "Name is required": "Name is required",
                "Create": "Create",
                "Page not found": "Page not found",
                "Sorry this page not found! Go to main page": "Sorry this page not found! Go to main page",
                "To pay at": "To pay at",
                "Type amount value.": "Type amount value.",
                "Continue": "Continue",
                "Back": "Back",
                "Reset": "Reset",
                "Last step": "Last step",
                "Select paid date.": "Select paid date.",
                "Paid At is required": "Paid At is required",
                "Summary": "Summary",
                "Receipt at": "Receipt at",
                "Edit revenue": "Edit revenue",
                "Repeat revenue": "Repeat revenue",
                "Frequency": "Frequency",
                "Monthly": "Monthly",
                "Weekly": "Weekly",
                "Yearly": "Yearly",
                "User profile": "User profile",
                "Hello": "Hello",
                "Update your password": "Update your password",
                "Old password": "Old password",
                "Confirm password": "Confirm password",
                "Fields should be same.": "Fields should be same.",
                "Wrong password repeat!": "Wrong password repeat!",
                "Messages": "Messages",
                "Edit": "Edit",
                "Save draw": "Save draw",
                "Complete": "Complete",
            }
        },
        pl: {
            translation: {
                "Connecting to chat, please wait...": "Nawiązuję połączenie...",
                "Welcome": "Witaj",
                "Login": "Zaloguj się",
                "Username": "Nazwa użytkownika",
                "Password": "Hasło",
                "Field is required": "Pole jest wymagane",
                "Profile": "Profil",
                "Logout": "Wyloguj się",
                "Filters": "Filtry",
                "Month": "Miesiąc",
                "Not available": "Niedostępne",
                "Real expenses list": "Lista wydatków",
                "Show list": "Pokaż listę",
                "Search": "Szukaj",
                "Clear search value": "Wyczyść",
                "Description": "Opis",
                "Amount": "Kwota",
                "Total amount": "Łączna kwota",
                "Balance": "Saldo",
                "Category": "Kategoria",
                "Planned": "Planowany",
                "Paid at": "Data płatności",
                "Actions": "Akcje",
                "No data": "Brak danych",
                "rows per page": "elementów na stronie",
                "Edit real expense": "Edytuj wydatek",
                "Category is required": "Kategoria jest wymagana",
                "Category (from planned expense)": "Kategoria (pobrana z planowanego wydatku)",
                "Description is required": "Opis jest wymagany",
                "Amount is required": "Kwota jest wymagana",
                "Cancel": "Anuluj",
                "Save": "Zapisz",
                "Submit": "Wyślij",
                "Create new": "Utwórz nowy",
                "List": "Lista",
                "Name": "Nazwa",
                "Name is required": "Nazwa jest wymagana",
                "Create": "Utwórz",
                "Page not found": "Nie odnaleziono strony",
                "Sorry this page not found! Go to main page": "Przepraszamy ale strona nie istnieje! Przejdź do strony głównej",
                "To pay at": "Data zapłaty",
                "Type amount value.": "Wpisz kwotę",
                "Continue": "Dalej",
                "Back": "Wstecz",
                "Reset": "Resetuj",
                "Last step": "Ostatni krok",
                "Select paid date.": "Zaznacz datę płatności.",
                "Paid At is required": "Data płatności jest wymagana",
                "Summary": "Podsumowanie",
                "Receipt at": "Data otrzymania",
                "Frequency": "Częstotliwość",
                "Monthly": "Miesięcznie",
                "Weekly": "Tygodniowo",
                "Yearly": "Rocznie",
                "Times amount": "Ilość powtórzeń",
                "Times amount is required": "Ilość powtórzeń jest wymagana",
                "Generated dates": "Wygenerowane daty",
                "User profile": "Profil użytkownika",
                "Hello": "Witaj",
                "Update your password": "Zaktualizuj swoje hasło",
                "Old password": "Stare hasło",
                "Confirm password": "Potwierdź hasło",
                "Fields should be same.": "Pola muszą być takie same.",
                "Wrong password repeat!": "Błędne hasło, musisz je poprawić!",
                "Messages": "Wiadomości",
                "Edit": "Edytuj",
                "Bad month value! Pattern is yyyy-MM.": "Błędna wartość! Wzór yyyy-MM",
                "Save draw": "Zapisz szkic",
                "Complete": "Gotowe",
            }
        }
    },
    lng: "pl",
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    returnNull: false
});
